<template>
  <div class="subscribe default-page">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="row filter-row">
                <div class="col-12" style="text-align: center">
                  <h3>Assine já</h3>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div v-html="page.content" class="text-content"></div>
                </div>
              </div>
              <div class="row form-row">
                <div class="col-12" style="margin-bottom: 10px">
                  <h5>
                    <b>Solicite uma proposta</b>
                  </h5>
                </div>
                <div class="col-lg-12 col-12" v-if="magazines">
                  <div class="form-group">
                    <label for>Revistas de interesse</label>
                    <multiselect
                      v-model="contact.interested_magazines"
                      :multiple="true"
                      :options="magazines"
                      selectLabel="Selecione essa revista"
                      deselectLabel="Remova essa revista"
                      selectedLabel="Selecionada"
                      track-by="id"
                      label="name"
                      placeholder="Selecione as revistas"
                    ></multiselect>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label for>
                      Nome
                      <span class="required-field">*</span>
                    </label>
                    <input type="text" v-model="contact.name" class="form-control" />
                  </div>
                  <div class="form-group">
                    <label for>
                      Email
                      <span class="required-field">*</span>
                    </label>
                    <input type="text" v-model="contact.email" class="form-control" />
                  </div>
                </div>
                <div class="col-lg-6 col-12">
                  <div class="form-group">
                    <label for>
                      Celular
                      <span class="required-field">*</span>
                    </label>
                    <input type="text" v-model="contact.cellphone" v-mask="'(##) #####-####'" class="form-control" />
                  </div>
                </div>
                <div class="col-lg-6 col-12">
                  <div class="form-group">
                    <label for>Telefone</label>
                    <input type="text" v-model="contact.phone" v-mask="'(##) ####-####'" class="form-control" />
                  </div>
                </div>
                <div class="col-12">
                  <label for>Comentários</label>
                  <textarea cols="30" rows="5" v-model="contact.comments" class="form-control"></textarea>
                </div>
              </div>
              <div class="row">
                <div class="col-12" style="margin-top: 18px">
                  <button class="btn btn-primary float-right" v-on:click="send()">Solicitar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import subscribe_validate from "@/imports/validator/models/subscribe";
import validator from "@/imports/validator/validate";
import Multiselect from "vue-multiselect";
import Swal from "sweetalert2";
import { bus } from "@/main";

export default {
  name: "subscribe",
  components: {
    Multiselect
  },
  data() {
    return {
      page: {},
      magazines: [],
      contact: {}
    };
  },
  mounted() {
    this.getPageContent();
    this.getMagazines();
  },
  methods: {
    getPageContent: function() {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/content_pages_public/4`)
        .then(response => {
          this.page = response.data;
        });
    },
    getMagazines: function() {
      axios
        .get(
          `${process.env.VUE_APP_API_HOST}/api/magazines_public?page[number]=1&page[size]=50`
        )
        .then(response => {
          this.magazines = response.data.data;
        });
    },
    send: function() {
      let errors = validator.validate(this.contact, subscribe_validate.model);
      if (errors.length == 0) {
        bus.$emit("changeLoading", true);
        let promise = axios.post(
          `${process.env.VUE_APP_API_HOST}/api/subscribe_now`,
          this.contact
        );
        promise
          .then(response => {
            bus.$emit("changeLoading", false);
            Swal.fire({
              title: "Mensagem enviada com sucesso",
              icon: "success",
              onClose: () => {
                this.$router.push({ name: "Home" });
              }
            });
          })
          .catch(error => {
            bus.$emit("changeLoading", false);
            Swal.fire({
              title: "Ocorreu um erro.",
              icon: "error"
            });
          });
      } else {
        let html = "Preencha todos os campos obrigatórios.";
        if (errors.length < 4) {
          html = "";
          errors.forEach(el => (html += el.message + "<br>"));
        }
        Swal.fire({
          title: "Atenção",
          html: html,
          icon: "warning"
        });
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";

.subscribe {
  .form-row {
    margin-top: 1.5vw;
  }
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>